<template>
<div class="qq">
  <div class="index_top fcolumn">
    <div class="top_logos frow">
      <div class="top_logo">
        <img class="logo_img" :src="require('@/assets/images/index_04.png')" mode="widthFix">
      </div>
      <div class="top_right">
        <div class="top_name">桃江农商银行</div>
        <div class="top_e">TAOJIANG RURAL COMMERCIAL BANK</div>
      </div>
    </div>
    <div class="top_title">{{title}}</div>
  </div>
  
  <div class="search_box frow">
    <input class="signup_input w80" v-model="searchvalue" name="" placeholder="输入身份证号码" >
    <div class="search_right" @click="searchValue">
      <img class="search_img" :src="require('@/assets/images/search.png')" mode="widthFix">
    </div>
  </div>
  <div class="result fcolumn" v-if="state == 1">
    <div class="result_title"><div class="re_left">查询结果：</div><div class="re_right blue">审核通过</div></div>
    <div class="result_one" v-if="pass.is_pass == 0"><div class="re_left">笔试结果：</div><div class="re_right blue">未入围</div></div>
    <div class="result_title" v-if="pass.is_pass == 1"><div class="re_left">笔试成绩：</div><div class="re_right blue">{{pass.score}}分（入围）</div></div>
    <div class="result_one" v-if="pass.is_pass == 1"><div class="re_left">面试成绩：</div><div class="re_right blue">{{pass.face_score}}分</div></div>
    <div class="result_one" v-if="pass.is_pass == 1"><div class="re_left">总成绩：</div><div class="re_right blue">{{pass.total_score}}分</div></div>
    <div class="result_one" v-if="pass.is_pass == 1"><div class="re_left">名次：</div><div class="re_right blue">第{{pass.rank}}名{{pass.result == 1 ? '(入围)' : '（未入围）'}}</div></div>
    <div class="result_two" v-if="pass.is_pass == 1">(入围学生请于2023年5月9日上午8点在湖南城市学院土木楼616持准考证、身份证原件进行面试。)</div>
    <div class="result_download" @click="look()" v-if="pass.status == 1">打印准考证</div>
    <div class="result_download" @click="look2()" v-if="pass.status == 1">打印申报卡</div>
    <div class="time">准考证打印时间</div>
    <div class="time">{{pass.time ? pass.time : '未开放'}}</div> 
  </div>
  <div class="result fcolumn" v-if="state == 2">
    <div class="result_title">查询结果：<span class="red">审核不通过</span></div>
    <div class="result_reason">原因：{{reason}}</div>
    <div class="mark">提示：可前往首页点击『立即报名』重新提交资料。</div>
  </div>
  <div class="result fcolumn" v-if="state == 3">
    <div class="result_title">查询结果：<span class="red">{{message.text}}</span></div>
  </div>
  <div class="index_bottom fcolumn">
    <div class="bottom_name">桃江农商银行</div>
    <div class="bottom_code">Copyright © 2022 桃江农商银行</div>
  </div>
  <canvas width="400" height="400" id="my" style="position: absolute;top: -1000px;"></canvas>
  <div class="c-message" :class="message.status" v-show="message.show">
      <div class="c-message--main">
          <i class="c-message--icon" :class="message.type"></i>
          <div class="c-message--tip">{{message.text}}</div>
      </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'Search',
  data () {
    return {
      msg: '',
      searchvalue:'',
      bgzkz:require('../assets/images/zkz.png'),
      title:'',
      message: {
        show: '',
        type: '',
        status: '',
        text: '',
        time: '',
        timeout: ''
      },
      state:0,
      reason:'',
      pass:{
        status:'',
        time:'',
        score:''
      }
    }
  },
  methods:{
    goto(page){
        this.$router.push(page);
    },
    look(){
        if (this.$isMobile()) {
          this.$request.Alert(this,'手机端暂不支持，请在谷歌浏览器中打开', 'warning', '3000');
        } else {
          this.$router.push({
            path:'./Ticket',
            query:{
              cid:this.searchvalue
            }
          });
        }
    },
    look2(){
        if (this.$isMobile()) {
          this.$request.Alert(this,'手机端暂不支持，请在谷歌浏览器中打开', 'warning', '3000');
        } else {
          this.$router.push('./Safe');
        }
    },
    searchValue(){
      var config = {};
      if(this.searchvalue){
        this.$request.get('/api/user/get-result', {'cid':this.searchvalue},config, response => {
            if(response.data.code == 200){
              this.$request.Alert(this,response.data.message, 'success', '3000');
              this.state = 1;
              this.pass = response.data.data;
            }else if(response.data.code == 201){
              this.$request.Alert(this,response.data.message, 'warning', '3000');
              this.state = 2;
              this.reason = response.data.data.reason;
            }else{
              this.$request.Alert(this,response.data.message, 'warning', '3000');
              this.state = 3;
            }
        }, error => {
            console.log(error)
        });
      }
      
    },
    toCanvas(){
      var mycanvas = document.getElementById('my');
			var ctx = mycanvas.getContext('2d');
			var img = new Image();
			img.onload = function(){
				// 将图片画到canvas上面上去！
        ctx.drawImage(img,0,0,100,100);
			}
      img.src = this.bgzkz;
    },
    // 图片地址和图片名称
    download(){
      var canvas = document.getElementById('my');
      canvas.toDataURL("image/png");
      const base64 = canvas.toDataURL();
      const myBlob = this.dataURLtoBlob(base64)
      const myUrl = URL.createObjectURL(myBlob)
      this.downloadFile(myUrl, '准考证');
    },
    dataURLtoBlob(dataurl){
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    downloadFile(url, name){
      const a = document.createElement('a')
      a.setAttribute('href', url)
      a.setAttribute('download', name)
      a.setAttribute('target', '_blank')
      const clickEvent = document.createEvent('MouseEvents')
      clickEvent.initEvent('click', true, true)
      a.dispatchEvent(clickEvent)
    }
  },
  mounted() {
    this.toCanvas();
    this.title = localStorage.getItem('title');
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .index_top{
    width:100%;
    background: #940709;
    height:150px;
    margin-bottom:100px;
  }
  .top_logos{
    padding:10px 5%;
  }
  .top_logo{
    width:100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logo_img{
    width:69px;
    height:69px;
  }
  .top_right{
    color:white;
  }
  .top_name{
    height:40px;
    font-weight: bold;
    font-size:25px;
    line-height:40px;
    letter-spacing:10px;
  }
  .top_e{
    height:40px;
    font-size:10px;
    line-height:40px;
    margin-top:-5px;
  }
  .top_title{
    height:50px;
    background: #940709;
    color:white;
    font-weight: bold;
    font-size:23px;
    text-align: center;
    line-height:50px;
  }
  .mark{
    font-size:15px;
    margin-top:10px;
    color: #940709;
  }
  .time{
    font-size:14px;
    width:95%;
    margin:10px auto 0;
    text-align: center;
  }
  .search_box{
    width:80%;
    margin:100px auto 70px;
  }
  .signup_input{
    height:40px;
    line-height:40px;
    border:1px solid #D4DADD;
    color:#666666;
    background:#F3F3F3;
    padding-left:10px;
    font-size:16px;
  }
  .search_right{
    width:42px;
    height:42px;
    background:#94070A;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left:5px;
  }
  .search_img{
    width:35px;
  }
  .result{
    align-items: center;
  }
  .result_title{
    color:#333333;
    font-size:20px;
    margin-bottom:20px;
    display: flex;
    flex-direction: row;
    width: 100%;
  }
  .re_left{
    width:50%;
    text-align: right;
  }
  .re_right{
    width:50%;
  }
  .result_one{
    color:#333333;
    font-size:20px;
    margin-bottom:20px;
    display: flex;
    flex-direction: row;
    width: 100%;
  }
  .result_two{
    color:#333333;
    font-size:15px;
    margin-bottom:20px;
  }
  .result{
    color:#333333;
    font-size:20px;
    margin-bottom:20px;
  }
  .red{
    color:#94070A;
  }
  .blue{
    color:#154294;
  }
  .result_reason{
    color:#333333;
    font-size:15px;
  }
  .result_download{
    color:#94070A;
    border:1px solid #94070A;
    font-size:20px;
    min-width:100px;
    height:40px;
    line-height:38px;
    text-align: center;
    padding:0 20px;
    cursor: pointer;
    margin-bottom:20px;
  }
  .index_bottom{
    width:500px;
    height:40px;
    border-top:5px solid #E6E6E6;
    color:#999999;
    font-size:12px;
    /* position: fixed; */
    padding:10px 0;
    margin-top:50px;
  }
  .bottom_name{
    height:20px;
    line-height:20px;
    text-align: center;
    font-weight: bold;
  }
  .bottom_code{
    height:25px;
    line-height:25px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Search.vue